import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { reducer, userFeatureKey } from './user-reducer';
import { payrateFeatureKey, payRateReducer } from './pay-rate-reducer';
import { PayRateEffects } from './effects/pay-rate.effects';
import { EnvironmentProviders } from '@angular/core';

export const providePerdiemStore = (): EnvironmentProviders[] => [
    provideState(userFeatureKey, reducer),
    provideState(payrateFeatureKey, payRateReducer),
    provideEffects(PayRateEffects)
];
